import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"
import { CursorType } from "utils/types"

export type FHRequestMessageType = {
    key: string;
    uuid: string;
    identity: string;
    request: string;
    message_id: string;
    subject: string;
    sender: string;
    original_content: string;
    content: string;
    content_plain: string;
    content_type: string;
    seen_by_client: boolean;
    client_viewable: boolean;
    original_to: string;
    original_cc: string;
    voice_url: string;
    service_sent: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: FHRequestMessageType) => void;
};

// Domain object FHRequestMessage
export class FHRequestMessage implements FHRequestMessageType {
    key = "";
    uuid = "";
    identity = "";
    request = "";
    message_id = "";
    subject = "";
    sender = "";
    original_content = "";
    content = "";
    content_plain = "";
    content_type = "";
    seen_by_client = false;
    client_viewable = false;
    original_to = "";
    original_cc = "";
    voice_url = "";
    service_sent = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: FHRequestMessageType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: FHRequestMessageType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class FHRequestMessageStore extends BaseStore<FHRequestMessageType, FHRequestMessage> {

    async sendMessage(identity: string, request: string, content: string) {
        const data = { identity, request, content };
        console.log("sendMessage data: %o", data);
        const response = await api_post("/request/message/create", data);
        if(response.ok) {
            const data = await response.json();
            console.log("FHRequestMessageStore.sendMessage response", data);
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    async supportHelpRespond(workKey: string, request: string, message: string, clock: string) {
        const data = { identity: workKey, request, message, clock };
        const response = await api_post("/request/help/respond", data);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }



    // async sendAssistantMessage(identity: string, request: string, content: string) {
    //     const data = { identity, request, content };
    //     const response = await api_post("/request/message/assistant-create", data);
    //     if(response.ok) {
    //         const data = await response.json();
    //         this.receiveUpdate(data);
    //         return data;
    //     }
    //     return null;
    // }


    async fetchListByRequest(identity: string, request: string, cursor?: CursorType): Promise<FHRequestMessageType[]>  {
        const url = "/request/message/list";
        const data = { identity, request, cursor: cursor || "" };

        const response = await api_get(url, data);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByRequest(identity, request, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but FHRequestStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };


    modelConstructor() {
        return FHRequestMessage;
    }

}
